import * as React from 'react';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { IdentityService } from 'src/core/services/identity.service';

interface Props extends ComponentViewProps<DataSet<QuoteItineraryGroupSummary>> {
	onItemDoubleClicked?: (item: QuoteItineraryGroupSummary) => void;
}

@observer
export class QuoteItineraryGroupListView extends React.Component<Props, {}> {
	@resolve
	private identityService: IdentityService;

	private permissions = ['QuoteGroup', 'QuoteGroup_Write', 'QuoteGroup_Write_Own'];

	private columns: Column[] = [
		{
			key: 'quoteNumber',
			title: 'Number',
			dataIndex: 'quoteNumber',
			render: (text, record: QuoteSummary) => <Link to={`/bookings/groups/${record.id}`}>{text}</Link>,
		},
		{
			key: 'tourItineraryName',
			title: 'Itinerary Name',
			dataIndex: 'tourItineraryName'
		},
		{
			key: 'tourItineraryService',
			title: 'Itinerary Service',
			dataIndex: 'tourItineraryService'
		},
		{
			key: 'dateFrom',
			title: 'Start date',
			dataIndex: 'dateFromText'
		},
		{
			key: 'dateTo',
			title: 'End date',
			dataIndex: 'dateToText'
		},
		{
			key: 'managedById',
			title: 'Managed by',
			dataIndex: 'managedByUserName'
		},
		{
			key: 'reservationsCount',
			title: 'Reservation count',
			dataIndex: 'reservationsCount'
		},
	]

	public render() {
		const { model } = this.props;

		const isReadonly = !this.permissions.some((r) => this.identityService.isAuthorized(r));

		return (
			<DataTableView
				setBusy={this.props.setBusy}
				hideToolbar={isReadonly ? ToolbarVisibility.hideModifyButtons : null}
				columns={this.columns}
				model={model}
				itemDoubleClick={this.onItemClick}
			/>
		);
	}

	private onItemClick = (item: QuoteItineraryGroupSummary): void => {
		if (this.props.onItemDoubleClicked) {
			this.props.onItemDoubleClicked(item);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/list/quote-group-list.view.tsx